import { Box, Text } from '@zillow/constellation-10';

export const StyledBillingTableErrorRow = ({
  children,
  ...props
}: { children: React.ReactNode } & React.ComponentProps<typeof Box>) => (
  <Box
    css={{
      textAlign: 'center',
      fontWeight: 'bold',
      color: 'white',
      padding: '16px',
      background: '#d52e2e',
      fontSize: '16px',
    }}
    {...props}
  >
    <Text css={{ color: 'white' }}>{children}</Text>
  </Box>
);
